import React from 'react';
import PropTypes from 'prop-types';
import convertTcmLink from '../../utils/convertTcmLink';
import Collapse from '../Global/Collapse/Collapse';
import Icon from '../Global/Icons/Icon';

const Accordion = ({ title, detail }) => {
  let content = null;
  if (detail) {
    content = <div className="accordion__detail"><p>{convertTcmLink(detail)}</p></div>;
  }

  return (
    <div className="accordion">
      <Collapse
        trigger={
          <span className="accordion__title">
            {title}
            {detail &&
              <Icon name="arrow-down" size="m" fill="black" />
            }
          </span>
        }
        content={content}
      />
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.string,
  detail: PropTypes.string,
};

export default Accordion;



// WEBPACK FOOTER //
// ./library/app/components/Content/Accordion.js